import React, { useEffect } from "react";
import { getAntdMarkIcon } from "@/services/api/setting/orderMark";
import { useOrderMarkStore } from "@/store/hooks";
import { Tooltip } from "antd";
import { observable } from "mobx";
import { observer } from "mobx-react-lite";
import classNames from "classnames";

interface OrderMarkProps {
    id?: number;

    className?: string;

    style?: React.CSSProperties;
}

let store = observable({
    loading: false,
});

const OrderMark: React.FC<OrderMarkProps> = function (props) {
    const { id, className, style } = props;

    const orderMarkStore = useOrderMarkStore();

    useEffect(() => {
        if (orderMarkStore.isInit) {
            return;
        }

        if (store.loading) {
            return;
        }

        store.loading = true;

        orderMarkStore.loadList();
    }, []);

    if (!id) {
        return null;
    }

    const orderMark = orderMarkStore.mapping.get(id);

    if (!orderMark) {
        return null;
    }

    const IconComponent = getAntdMarkIcon(orderMark.icon);

    if (!IconComponent) {
        return null;
    }

    return (
        <span className={classNames(className)} style={style}>
            <Tooltip title={orderMark.remark}>
                <IconComponent style={{ color: orderMark.color }} />
            </Tooltip>
        </span>
    );
};

export default observer(OrderMark);
